import { gql } from '@apollo/client';

export const PATCH_COURSE_MUTATION = gql`
    mutation patchCourse($input: CourseInput!) {
        result: patchCourse(input: $input) {
            id
            locales {
                locale
                name
                description
            }
            isIlt
            thumbnailImage {
                id
                name
                url
                __typename
            }
            heroImage {
                id
                name
                url
                __typename
            }
            tags
            points
            isPublic
            isSequential
            enrollmentCount
            learningObjects {
                edges {
                    assignment {
                        status
                        scormState
                        __typename
                    }
                    node {
                        id
                        locales {
                            locale
                            name
                            description
                        }
                        duration
                        content {
                            id
                            url
                            __typename
                        }
                        __typename
                    }
                    __typename
                }
                __typename
            }
            categoryIds
            segmentIds
            brandIds
            localeIds
            companyRelationshipIds
            metadata
            createdAt
            updatedAt
            __typename
        }
    }
`;